<div class="page-title-area">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/gerenciadoras-listado">Listado de Gerenciadoras</a></li>
        <li>Modificar Gerenciadora</li>
        <li><app-menu></app-menu></li>
      </ul>
      <h2>Modificar Gerenciadora</h2>
      <h4 *ngIf="this.signoGerencia">{{signoGerencia.nombre}}</h4>
    </div>
  </div>
</div>

<div class="andorra-apply-content ptb-70  animate__animated animate__fadeIn">
  <div class="container">
    <div class="row mx-auto">
      <div class="col-lg-12 col-md-12">
        <div class="apply-form">
          <form [formGroup]="form" (ngSubmit)="updateGerencia()">

            <div class="row">
              <div class="col-lg-8 col-md-8 col-xs-12">
                <div class="form-group">
                  <mat-form-field class="example-full-width" appearance="fill" [style.width.%]=100>
                    <mat-label>Gerenciadora</mat-label>
                    <input formControlName="nombre" matInput placeholder="Gerenciadora"
                      [class.is-invalid]="gerenciaNoValido" autocomplete="off">
                    <mat-error *ngIf="gerenciaNoValido">Ingrese una gerenciadora</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-xs-12">
                <div class="form-group">
                  <mat-slide-toggle formControlName="activa">Activa</mat-slide-toggle>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-4">
                <button type="button" routerLink="/gerenciadoras-listado"
                  class="btn btn-warning">Cancelar</button>
              </div>
              <div class="col-lg-4 col-md-4">
                <button [disabled]="!form.valid" type="submit">Guardar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>